import { get, post, put, postFormData, destroy } from './fetch'

export const getProfile = () => {
  return get(`/api/seller/profile`);
}

export const updateProfile = (name, address, cellPhone,) => {
  return put(`/api/seller/profile`, { name, address, cellPhone });
}

export const addSeller = (seller) => {
  return post(`/api/seller/add`, seller, false);
}

export const getDiscount = (promo, isLoggedIn = false) => {
  return isLoggedIn ? get(`/api/seller/subscription/promo/${promo}`, true) : get(`/api/seller/promo/${promo}`, false);
}

export const completeProfile = (address, businessName, password, oldPassword) => {
  return put(`/api/seller/profile/complete`, { fullAddress: address, businessName, password, oldPassword });
}

export const getPaymentMethods = () => {
  return get(`/api/seller/payment-method`, true);
}

export const addSubscription = (data) => {
  return post(`/api/seller/add/subscription`, data, false);
}

export const getServiceCandidateRequestBidsCount = () => {
  return get(`/api/seller/candidate/requests/count`);
}

export const requestMoreInfo = (data) => {
  return post(`/api/seller/request/more-info`, data, true);
}

export const getInvoiceData = (itemsPerpage = 10, page = 1, type) => {
  return get(`/api/seller/invoice-data?itemsPerPage=${itemsPerpage}&page=${page}&type=${type}`, true);
}

export const getPreferences = () => {
  return get(`/api/seller/preferences`);
}

export const savePreferences = (preferences) => {
  return post(`/api/seller/preferences/save`, { preferences }, true);
}

export const isValidToBid = (singleBuyerRequestID) => {
  return get(`/api/seller/requests/${singleBuyerRequestID}/valid-to-bid`);
}

export const showRequests = () => {
  return get(`/api/seller/show-requests`);
}

export const newLeadAlert = (data) => {
  return post(`/api/seller/new-lead-alert`, data, false);
}

export const alertBusinessDetailsCompleted = (data) => {
  return post(`/api/seller/business-details-completed`, data, false);
}

export const acceptConfirmationPrice = (accessToken, sbrID) => {
  const data = {
    accessToken: accessToken
  }
  return post(`/api/seller/requests/${sbrID}/price/confirmation/accept`, data, true);
}
export const uploadSignatureImage = (data) => {
  return postFormData(`/api/seller/termsOfService/signatureImage`, data, true)
}
export const getSellerInfo = (catSEOName) => {
  return get(`/api/seller/getSellerInfo/${catSEOName}`, true);
}
export const getTOSInfo = () => {
  return get(`/api/seller/getTOSInfo`, true);
}

export const addNewPaymentMethod = (data) => {
  return post(`/api/seller/payment-method/add`, data, true);
}

export const getSellerPaymentMethods = (sellerID) => {
  return get(`/api/seller/${sellerID}/payment-methods`, true);
}

export const getPaymentIntent = (sellerID, amount) => {
  return get(`/api/seller/${sellerID}/payment-intent/${amount}` , true);
}

export const swapPaymentMethods = (data) => {
  return post(`/api/seller/payment-method/swap`, data, true);
}

export const removePaymentMethods = (paymentMethodID) => {
  return put(`/api/seller/payment-method/${paymentMethodID}/remove`, {} , true);
}

// *********************** SAAS start ***********************

export const createSellerCustomerRequest = (data) => {
  return post(`/api/saas/seller/request/create`, data, true);
}

export const getSellerCustomerSearch = (queryParams) => {
  return post(`/api/saas/seller/customer/search`, queryParams , true);
}

export const getSellerCustomerRequestForSeller = (requestToken) => {
  return get(`/api/saas/seller/request/token/${requestToken}/detail` , true);
}

export const getSellerCustomerRequestForBuyer = (sellerSEOName,requestToken) => {
  return get(`/api/saas/seller/${sellerSEOName}/request/${requestToken}/search` , false);
}

export const submitSellerCustomerRequestFormForSeller = (requestToken, requestData) => {
  return post(`/api/saas/seller/request/${requestToken}/submit` , requestData,  true);
}

export const submitSellerCustomerRequestFormForBuyer = (sellerSEOName, requestToken, requestData) => {
  return post(`/api/saas/seller/${sellerSEOName}/request/${requestToken}/submit` , requestData , false);
}

export const getSellerCustomerRequestsList = (option) => {
  return get(`/api/saas/seller/request/list?page=${option.activePage}&limit=${option.rowsPerPage}`, true);
}

export const updateSellerNotes = (scRequestID,sellerNotes) => {
  return post(`/api/saas/seller/${scRequestID}/notes/update`, {sellerNotes}, true);
}

export const getSCRequestInvoiceDetails = (scRequestID) => {
  return get(`/api/saas/seller/request/${scRequestID}/invoice/detail`, true);
}

export const getSellerInvoiceItemTypesList = () => {
  return get(`/api/saas/seller/invoice/item/types/list`, true);
}

export const removeInvoiceItems = (scsRequestInvoiceID,scsRequestInvoiceItemIDs) => {
  return post(`/api/saas/seller/request/invoice/${scsRequestInvoiceID}/items/remove`, {scsRequestInvoiceItemIDs}, true);
}

export const addInvoiceItems = (scsRequestInvoiceID,scsInvoiceItemTypeID) => {
  return post(`/api/saas/seller/request/invoice/${scsRequestInvoiceID}/item/add`, {scsInvoiceItemTypeID}, true);
}

export const updateSellerCustomerData = (sellerCustomerID, sellerCustomerParams) => {
  return post(`/api/saas/seller/customer/${sellerCustomerID}/update`, sellerCustomerParams, true);
}

export const sendFormEntrySMSToCustomer = (scRequestID) => {
  return post(`/api/saas/seller/request/${scRequestID}/form/link`, {}, true);
}

export const toggleInvoiceItemTypeDefault = (scsInvoiceItemTypeID) => {
  return put(`/api/saas/seller/invoice/item/type/${scsInvoiceItemTypeID}/toggle/default`, {}, true);
}

export const getCategoryItemTypeList = () => {
  return get(`/api/saas/seller/category/invoice/item/types/list`, true);
}

export const addInvoiceItemType = (scCategoryInvoiceItemTypeID,rate,isDefaultValue) => {
  return post('/api/saas/seller/invoice/item/type/add', {scCategoryInvoiceItemTypeID: scCategoryInvoiceItemTypeID, rate: rate, isDefault: isDefaultValue }, true); 
}

export const deleteInvoiceItemType = (scsInvoiceItemTypeID) => {
  return destroy(`/api/saas/seller/invoice/item/type/${scsInvoiceItemTypeID}/delete`, true); 
}

export const deleteSCRequest = (scRequestID) => {
  return put(`/api/saas/seller/request/${scRequestID}/delete`, {}, true);
}

export const updateSCRequestBookingDate = (appointmentDate, serviceID, scRequestID) => {
  return post(`/api/saas/seller/request/${scRequestID}/appointment/book`, {appointmentDate, serviceID}, true);
}

export const resetBookedSCRequest = (scRequestID) => {
  return post(`/api/saas/seller/request/${scRequestID}/appointment/reset`, {}, true);
}

export const getSCRequestNotesList = (scRequestID) => {
  return get(`/api/saas/request/${scRequestID}/note/list`, true);
}

export const addSCRequestNote = (scRequestID, note) => {
  return post(`/api/saas/request/${scRequestID}/note/add`, { note }, true);
}

export const deleteSCRequestNote = (scRequestID, scrNoteID) => {
  return destroy(`/api/saas/seller/request/${scRequestID}/note/${scrNoteID}/delete`, true);
}

// *********************** SAAS end ***********************
export const sellerAcceptingJobsUpdate = (sellerID, acceptingJobs) => {
  return put(`/api/seller/${sellerID}/accepting-jobs/update`, { acceptingJobs: acceptingJobs }, true);
}
export const getSellerSchedules = () => {
  return get(`/api/seller/schedules`, true);
}
export const getDaysOfWeek = () => {
  return get(`/api/seller/schedule/days-of-week`, true);
}

export const updateSellerSchedule = (sellerScheduleID, startTime, endTime, isActive) => {
  return post(`/api/seller/schedule/${sellerScheduleID}/update`, { startTime: startTime, endTime: endTime, isActive: isActive }, true);
}




    

